import { useState } from "react";
import { Button, Icon, Table } from "semantic-ui-react";

import { Option } from "models/Option";
import CarrierCapacityFormModal from "../../forms/CarrierCapacityForm/CarrierCapacityFormModal";
import CarrierPreferredLaneTableRow from "./CarrierPreferredLaneTableRow";
import CarrierCapacityLoadingTableRow from "../CarrierCapacityLoadingTableRow";
import { getDefaultCarrierCapacityFormObject } from "../../forms/CarrierCapacityForm/utils/carrierCapacityFormDefaultFormObjects";
import CarrierCapacityNoCapacitiesTableRow from "../CarrierCapacityNoCapacitiesTableRow";
import { SelectedCarrier } from "models/SelectedCarrier";
import { useGetCarrierCapacities } from "components/CarrierCapacity/hooks/useGetCarrierCapacities";

type CarrierPreferredLaneTableProps = {
  carrier: SelectedCarrier;
  equipmentOptions: Option<number>[];
  refreshCarrierTimeline: () => void;
  preferredLanes: ReturnType<typeof useGetCarrierCapacities<"Preferred Lane">>;
};

const CarrierPreferredLaneTable = (props: CarrierPreferredLaneTableProps) => {
  const [isAddingPreferredLane, setIsAddingPreferredLane] = useState(false);

  const reloadCarrierData = () => {
    props.refreshCarrierTimeline();
    props.preferredLanes.mutate();
  };

  const getTableRows = () => {
    if (props.preferredLanes.isLoading) {
      return <CarrierCapacityLoadingTableRow columns={9} />;
    } else if (props.preferredLanes.data?.length) {
      return props.preferredLanes.data.map((preferredLane) => (
        <CarrierPreferredLaneTableRow
          key={preferredLane.id}
          carrier={props.carrier}
          preferredLane={preferredLane}
          equipmentOptions={props.equipmentOptions}
          reloadCarrierData={reloadCarrierData}
        />
      ));
    } else {
      return <CarrierCapacityNoCapacitiesTableRow columns={9} />;
    }
  };

  return (
    <div>
      <header>
        <h2>Preferred Lane</h2>

        <div>
          <Button primary onClick={() => setIsAddingPreferredLane(true)}>
            Add Preferred Lane
          </Button>
        </div>
      </header>

      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell>Origin</Table.HeaderCell>
            <Table.HeaderCell>Destination</Table.HeaderCell>
            <Table.HeaderCell>
              Expiration Date <Icon name="caret down" />
            </Table.HeaderCell>
            <Table.HeaderCell>Equipment</Table.HeaderCell>
            <Table.HeaderCell>Rate</Table.HeaderCell>
            <Table.HeaderCell>Note</Table.HeaderCell>
            <Table.HeaderCell>User Entered</Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>{getTableRows()}</Table.Body>
      </Table>

      {isAddingPreferredLane ? (
        <CarrierCapacityFormModal
          {...props}
          onSubmitCallback={reloadCarrierData}
          onClose={() => setIsAddingPreferredLane(false)}
          defaultValues={getDefaultCarrierCapacityFormObject("Preferred Lane")}
        />
      ) : null}
    </div>
  );
};

export default CarrierPreferredLaneTable;
